export const NAV_SIZE_STORAGE_KEY = 'navSize';
export const NAV_SIZE_MAX = 'max';
export const NAV_SIZE_MIN = 'min';

export const VERIFICATION_CREATE_SR_ERROR = 'Please verify your email address ' +
  'before creating service requests';
export const VERIFICATION_CREATE_PARTICIPANTS_ERROR = 'Please verify your email ' +
  'address before creating participants';
